function t(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}export{t as default};
//# sourceMappingURL=nonIterableRest.js.map
